import React from 'react'
import Home from '../fetures/home/Home'

const HomePage = () => {
  return (
    <Home/>
  )
}

export default HomePage;
